<template>
    <div id="app" v-loading="loading">
        <router-view/>
    </div>
</template>
<script>
import { setActiveDashboard } from '@/config/dashboard';
export default {
    data() {
        return{
            title: '',
            loading: false,
        }
    },
    async created() {
        this.loading = true;
        await apiGet('/v2/profile', {
            dashboard: true
        }).then(res => {
            this.loading = false;
            let data = res.data;
            this.$store.commit('dataUser', data.user);
            this.$store.commit('dataDashboard', data.dashboard);
            this.$store.commit('dataConfig', data.config);
        });
        await getMoney();
    },
    watch: {
        router(val){
            this.setActiveDashboard(val);
            window.scrollTo(0,0)
        },
        dashboard: {
            handler(val){
                this.setActiveDashboard(this.$route.name);
            },
            deep: true,
        },
        title(val){
            document.title = val;
            this.$store.commit('dataTitle', val);
        },
        errorUpdateRv: {
            handler(val){
                if(Object.keys(val).length > 0){
                    this.$message({
                        message: 'Vui lòng kiểm tra lại dữu liệu',
                        type: 'warning',
                        center: true,
                    })
                }
            },
            deep: true
        }
    },
    computed: {
        router(){
            return this.$route.name;
        },
        dashboard(){
            return this.$store.state.dashboard
        },
        errorUpdateRv(){
            return this.$store.state.errorPutRv;
        }
    },
    methods: {
        setActiveDashboard(nameRouter){
            setActiveDashboard(nameRouter, this);
        },
    },
}
</script>
<style lang="scss">
    button {
        &:focus {
            box-shadow: none !important;
            outline: none !important;
        }
    }
    .ldc-loading{
        z-index: 100001 !important;
    }
    .ldc-message, .ldc-alert-box{
        z-index: 100000 !important;
    }
    #app{
        min-height: 100vh;
    }
    #nprogress{
        z-index: 10000000;
        position: relative;
        .spinner{
            display: none!important;
        }
        .bar {
            background: #dc3545 !important;
            height: 3px !important;
        }
    }
    .background-transparent{
        background: transparent !important;
    }
    *{
        font-family: 'Open Sans', sans-serif;
        padding: 0;
        margin: 0;
    }
    .show-menu{
        animation: show-menu 250ms cubic-bezier(0,0,.2,1) 0ms;
    }
    @-webkit-keyframes show-menu {
        0% {
            transform: translate(-100%);
        }
        100% {
            transform: translate(0);
        }
    }

    @keyframes show-menu {
        0% {
            transform: translate(-100%);
        }
        100% {
            transform: translate(0);
        }
    }
    div[input-search]{
        height: 0;
        animation-fill-mode: both;
        animation-timing-function: ease-out;
        transition: height 0.2s ease-in-out 0s;
        overflow: hidden;
    }
    .radius-ios {
        border-radius: 13px !important;
    }
    .input-vg {
        border-radius: 4px;
        border: 1px solid rgba(0,0,0, 0.2);
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        width: 100%;
        font-size: 14px;
    }
</style>
